import { formatPrice } from '@/shared/lib/utils/formatPrice';

export const INVOICE_AMOUNT_PLACEHOLDER = '—';

/**
 * Суммы приходят `null`, когда у студента счета в разных валютах — сервер отказывается
 * их складывать. В этом случае показываем прочерк, а не ноль: ноль читается как
 * «долгов нет», и это неправда.
 */
export const formatInvoiceAmount = (
  amount: number | null | undefined,
  currency: string | null | undefined,
): string => {
  if (typeof amount !== 'number' || !currency) return INVOICE_AMOUNT_PLACEHOLDER;

  return formatPrice(amount, currency);
};

/**
 * Сумма без символа валюты и с пробелом между разрядами — как в макете плиток
 * баланса: `30 000`. Символ валюты там вынесен в подпись, а не стоит перед числом.
 */
export const formatInvoiceValue = (amount: number | null | undefined): string => {
  if (typeof amount !== 'number') return INVOICE_AMOUNT_PLACEHOLDER;

  return new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 })
    .format(amount)
    .replace(/,/g, ' ');
};

/** Символ валюты для подписи плитки: `GBP` → `£`. Пусто, если валюта неизвестна. */
export const getCurrencySymbol = (currency: string | null | undefined): string | null => {
  if (!currency) return null;

  try {
    return (
      new Intl.NumberFormat('en-GB', { style: 'currency', currency })
        .formatToParts(0)
        .find((part) => part.type === 'currency')?.value ?? null
    );
  } catch {
    // Неизвестный код валюты — подпись обойдётся без символа.
    return null;
  }
};
